import Reveal from "./ui/reveal";
import brain from "@/assets/icons/finanzas_icon.svg";


export default function ScaleBanner() {
  return (
    <section className="relative overflow-hidden bg-nodric-blue py-20 md:py-28">
      <img className="absolute -right-10 -bottom-20 h-128 w-128 -rotate-12 bg-white/10" src={brain}></img>

      <Reveal className="relative z-10 mx-auto max-w-4xl px-6 text-center">
        <h2 className="font-display text-2xl leading-snug font-medium tracking-[0.06em] text-white md:text-4xl">
          Escala tu negocio con soluciones empresariales, con unos pocos clicks.
        </h2>
      </Reveal>
    </section>
  );
}
